<template>
  <div id="Index">
    <div class="color-type">Primary Color Color</div>
    <div class="color-row">
      <input class="color-picker" type="color" v-model="primaryColor"> <input class="color-input" type="text" v-model="primaryColor" :style="{ borderColor: primaryColor }" @change="changePrimaryColor">
    </div>
    <div class="color-type">Primary Dark Color</div>
    <div class="color-row">
      <input class="color-picker" type="color" v-model="primaryColorDark"> <input class="color-input" type="text" v-model="primaryColorDark" :style="{ borderColor: primaryColorDark }">
    </div>
    <div class="color-type">Secondary Color</div>
    <div class="color-row">
      <input class="color-picker" type="color" v-model="secondaryColor"> <input class="color-input" type="text" v-model="secondaryColor" :style="{ borderColor: secondaryColor }">
    </div>
    <div class="language-group">
      <div class="language-row">
        <input type="radio" name="" id="" class="" checked="true"> <span class="" >한국어 (Korean)</span> 
      </div>
      <div class="language-row">
        <input type="radio" name="" id="" class="" disabled> <span class="">영어 (English)</span> 
      </div>
    </div>
    <div class="payment-information">
      <div class="row">
        <span class="title">Order Number: </span>
        <input type="text" class="value" v-model="paymentInformation.orderNumber">
      </div>
      <div class="row">
        <span class="title">API Key: </span>
        <input type="text" class="value" v-model="paymentInformation.APIKey">
      </div>
      <div class="row">
        <span class="title">Token: </span>
        <input type="text" class="value" v-model="paymentInformation.token">
      </div>
    </div>
    <div class="button-group">
      <button id="submit" @click="nextStep" :style="styleObejct">다음</button>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex'

export default {
  data () {
    return {
      primaryColor: '#1D9BF7',
      primaryColorDark: '#146BAB',
      secondaryColor: '#48A9EF',
      paymentInformation: {
        orderNumber: "8062444736789034105",
        APIKey: "ulTc0V8xP0HGb-JSsXTNn",
        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlfa2V5IjoidWxUYzBWOHhQMEhHYi1KU3NYVE5uIiwiZXhwIjoxNTk1MjUzMjc4LCJzdG9yZV9pZCI6ImFiM2QyZmQxNDgzMmY1OWUyMzJjMTAxZTNhMGNlNWMwZGQ2NjAxZGJhNDAyNTIwYjkyMTMxOGE1MmUyZmJiY2ZjNzY4YzVlMTQxZmMzODQyOTE2YTc0NTEwY2M4ZTBlZCJ9.i6uBr9euMggYfiz3wd96TsQ_EdjAYD27Esq8adDEGjY"
      }
    }
  },
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor'
    }),
    styleObejct: function () {
      return {
        '--color': this.primaryColor,
        '--color-active': this.primaryColorDark
      }
    }
  },
  created () {
    this.setTheme();
  },
  methods: {
    ...vuex.mapActions({
      'setColor': 'style/setColor'
    }),
    async setTheme () {
      await this.setColor({
        primaryColor: '#1D9BF7',
        primaryColorDark: '#146BAB',
        secondaryColor: '#48A9EF',
      })
    },
    async nextStep () {
      const { primaryColor, primaryColorDark, secondaryColor } = this;

      await this.setColor({
        primaryColor,
        primaryColorDark,
        secondaryColor,
      })

      // this.$router.push('/payment/selector');
      let url = `/?order_no=${this.paymentInformation.orderNumber}&api_key=${this.paymentInformation.APIKey}&token=${this.paymentInformation.token}`
      console.log(url)
      this.$router.push(url);
    },
    changePrimaryColor () {
      let colorCode = this.primaryColor.split('#')[1];
      console.log(colorCode)

      let rgb = {
        red: colorCode.substr(0, 2),
        green: colorCode.substr(2, 2),
        blue: colorCode.substr(4, 2)
      }

      let decimal = {
        red: parseInt(rgb.red, 16),
        green: parseInt(rgb.green, 16),
        blue: parseInt(rgb.blue, 16)
      }
      console.log(decimal)

      let deep = 0.7;
      let dark = {
        red: parseInt((decimal.red*deep).toString().split('.')[0]),
        green: parseInt((decimal.green*deep).toString().split('.')[0]),
        blue: parseInt((decimal.blue*deep).toString().split('.')[0]),
      }
      console.log(dark)

      let hex = {
        red: dark.red.toString(16),
        green: dark.green.toString(16),
        blue: dark.blue.toString(16)
      }
      console.log(hex)

      this.primaryColorDark = `#${hex.red}${hex.green}${hex.blue}`
    }
  }
}
</script>

<style lang="scss">
#Index {
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100vh;
  
  .color-type {
    margin-top: 48px;
    font-size: 24px;
    text-align: center;
  }
  .color-row {
    display: flex;
    justify-content:center;
    align-items: center;

    padding: 6px 12px;

    .color-picker {
      width: 120px;
      height: 40px;
      margin: 0 16px;
    }
    .color-input {
      width: 120px;
      height: 40px;

      font-size: 16px;

      border: solid 1px black;

      text-align: center;
    }
  }

  .language-group {
    margin-top: 24px;

    text-align: center;

    .language-row {
      margin-top: 16px;

      font-size: 16px;
    }
  }

  .payment-information {
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 480px;
      height: 24px;
      margin: 24px auto 0;

      .value {
        flex-basis: 360px;
        height: 36px;
        padding: 10px 10px;

        border-bottom: solid 1px #ccc;
        background-color: inherit;

        &:focus {
          border-bottom: solid 1px var(--color)
        }
      }


    }
  }

  .button-group {
    margin-top: 60px;

    text-align: center;

    #submit {
      width: 240px;
      height: 50px;

      border: solid 1px var(--color);
      border-radius: 25px;
      font-size: 17px;

      background-color: white;
      color: var(--color);

      &:active {
        border-color: var(--color-active);
        color: var(--color-active);
      }
    }
  }

}

</style>